import React from "react";
import "./skeleton.scss"; // Import CSS file for styling
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Grid';


const DetailSkeleton = () => {
  return (
    <div style={{}}>
     
      {/* For variant="text", adjust the height via font-size */}
   

      {/* For other variants, adjust the size with `width` and `height` */}
      <Grid container spacing={4} style={{ marginBottom:'10px',marginTop:'10px'}}>
      <Skeleton variant="rounded" height={400} width={2200  } />
      </Grid>
      <Grid style={{marginLeft:'5%'}}> 
      <Skeleton animation="wave" height={100} width={660}/> </Grid>
      
      <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-3'style={{marginLeft:'5%',marginRight:'5%'}}>
      {Array.from(Array(6)).map((_, index) => (
        <div key={index} className=" w-full">
          <Skeleton animation="wave" height={'200px'} width={'475px'}/>
        </div>
      ))}
    </div>

     

     
     <div style={{marginLeft:'5%',marginRight:'5%'}}>
     <Skeleton animation="wave" height={100} />
      <Skeleton animation="wave" height={300} />
     </div>
      

      <Skeleton variant="circular" />
      <Skeleton variant="rectangular" />
      <Skeleton variant="rounded" />
   
      {/* Add more shimmer divs for additional lines */}
    </div>
  );
};

export default DetailSkeleton;
